import { useEffect, useRef, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { RadioGroupList } from "stories/components/radioGroup/RadioGroup";
import { AssetBreakdownTable } from "./Table";

const generateTitle = (key) => {
  const keySections = key.split(">");
  if (keySections[1] === "other")
    return `${keySections[0]} ${keySections[1]} (${keySections[2]})`;
  else return `${keySections[1]} (${keySections[2]})`;
};

export const AssetBreakdownSection = ({
  groupedKeys = [],
  errors = {},
  prefixKey,
  titleParser,
  conditionalTable,
  conditionLabel,
  conditionValues,
  onConditionChange,
}) => {
  const [tabState, setTabState] = useState();

  const ref = useRef();
  useEffect(() => {
    for (const key of groupedKeys) {
      if (errors[key]) {
        setTabState(key);
        if (key !== groupedKeys[groupedKeys.length - 1]) {
          break;
        }
      }
    }
    if (
      Object.keys(errors).length > 0 &&
      groupedKeys.includes(Object.keys(errors)[0])
    ) {
      var element = ref.current;
      var headerOffset = 200;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }, [errors]); // eslint-disable-line
  return (
    <div className="mb-4" ref={ref}>
      <Tabs activeKey={tabState} onSelect={(k) => setTabState(k)}>
        {groupedKeys.map((key) => {
          return (
            <Tab
              key={key}
              eventKey={key}
              title={titleParser ? titleParser(key) : generateTitle(key)}
              tabClassName="capitalize"
            >
              {conditionalTable && (
                <RadioGroupList
                  label={conditionLabel(key)}
                  list={[
                    {
                      id: 1,
                      title: "Yes",
                      value: true,
                    },
                    {
                      id: 2,
                      title: "No",
                      value: false,
                    },
                  ]}
                  value={conditionValues[key]}
                  onChange={(value) => {
                    onConditionChange({
                      ...conditionValues,
                      [key]: value,
                    });
                  }}
                />
              )}
              {((conditionalTable && conditionValues[key]) ||
                !conditionalTable) && (
                <>
                  <div className="pr-2/5">
                    {errors[key] && (
                      <span className="text-red mb-2 d-block">
                        {errors[key]}
                      </span>
                    )}
                    <AssetBreakdownTable
                      title={titleParser && titleParser(key)}
                      dataKey={key}
                      prefixKey={prefixKey}
                    />
                  </div>
                </>
              )}
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};
